import initVueApp from "@/core.js";
const component = require(`./../views/Loyalty.vue`).default;
initVueApp(component);
